interface MapVariablesInput {
  filters: Record<string, unknown>
  search?: string
  sortings?: Array<{ field: string; order: string }>
}

interface MappedVariables {
  companyId: string
  search?: string
  filter?: Record<string, unknown>
  sortOrder: { field: string; order: string }
}

export const buildMapVariables = (companyId: string) => {
  return ({ filters, search, sortings }: MapVariablesInput): MappedVariables => {
    const filterObject: Record<string, unknown> = {}

    if (filters.status && Array.isArray(filters.status) && filters.status.length > 0) {
      filterObject.status = { in: filters.status }
    }

    if (filters.authorId && Array.isArray(filters.authorId) && filters.authorId.length > 0) {
      filterObject.authorId = { in: filters.authorId }
    }

    if (
      filters.competencyId &&
      Array.isArray(filters.competencyId) &&
      filters.competencyId.length > 0
    ) {
      filterObject.competencyId = { in: filters.competencyId }
    }

    if (filters.createdAt && typeof filters.createdAt === 'object') {
      const dateFilter = filters.createdAt
      const createdAtFilter: Record<string, string> = {}
      if ('from' in dateFilter && typeof dateFilter.from === 'string') {
        createdAtFilter.gte = dateFilter.from
      }
      if ('to' in dateFilter && typeof dateFilter.to === 'string') {
        createdAtFilter.lte = dateFilter.to
      }
      if (Object.keys(createdAtFilter).length > 0) {
        filterObject.createdAt = createdAtFilter
      }
    }

    const sortOrder = sortings?.[0]
      ? { field: sortings[0].field, order: sortings[0].order }
      : { field: 'createdAt', order: 'desc' }
    const filter = Object.keys(filterObject).length > 0 ? filterObject : undefined

    return {
      companyId,
      search,
      filter,
      sortOrder,
    }
  }
}
